import Swal from 'sweetalert2';

export const validarPermiso = (permisos, permiso) => {
  permisos.push('inicio', 'login');

  let autorizado = permiso.filter(function (permi) {
    return permisos.includes(permi);
  });
  if (autorizado.length > 0) {
    return true;
  } else {
    Swal.fire({
      position: 'center',
      icon: 'error',
      title: 'Usted no tiene permisos para ingresar a esta vista',
      showConfirmButton: true,
      timer: 5000
    });
  }
}

export const sanitizarString = (texto) => {
  texto = texto.trim();

  texto = texto.replace(/ /g, '-');
  texto = texto.toLocaleLowerCase();

  texto = texto.replace(/[áàäâªÁÀÂÄ]/g, 'a');
  texto = texto.replace(/[éèëêÉÈÊË]/g, 'e');
  texto = texto.replace(/[íìïîÍÌÏÎ]/g, 'i');
  texto = texto.replace(/[óòöôõÓÒÖÔ]/g, 'o');
  texto = texto.replace(/[úùüûÚÙÛÜ]/g, 'u');

  texto = texto.replace(/[ñÑ]/g, 'n');
  texto = texto.replace(/[çÇ]/g, 'c');

  texto = texto.replace(/[\\¨º~*#@|!\,·$%&/()?'¡¿[^<>+}{¨´><;:.\]]/g, '');
  texto = texto.replace(/--/g, '-');

  return texto;
};

export const sanitizarUrlSecciones = (url, data = null) => {
  if (data !== null) {
    let keys = Object.keys(data);
    for (let i = 0; i < keys.length; i++) {
      const k = keys[i];
      url = url.replace(':' + k, data[k]);
    }
  }

  return url;
};
